import { useNavigate } from "react-router-dom";
import { Box, CircularProgress, Typography } from "@mui/material";
// import { textStyle } from "src/styles/textstyle";
import Header from "src/components/header/header";
import Footer from "src/components/footer/footer";
import MainButton from "src/components/buttons/mainbutton";
import { getIsSignedIn } from "src/redux/reducers/user";
import SignupModal from "src/components/modals/SignUpModal";
import { useEffect, useState } from "react";

const NotFoundPage = ({ redirectPath }: { redirectPath?: string }) => {
  const navigate = useNavigate();
  const isSignedIn = getIsSignedIn();
  const [openSignUpModal, setSignUpModal] = useState(false);
  useEffect(() => {
    if (!isSignedIn) {
      setSignUpModal(true);
    }
  }, [isSignedIn]);

  return (
    <>
      <Header />
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          height: "100vh",
          textAlign: "center",
        }}
      >
        <Typography
          variant="h1"
          component="h2"
          sx={{ fontSize: "5rem", fontWeight: "bold", color: "#333" }}
        >
          404
        </Typography>
        <Typography sx={{ fontSize: "1.5rem" }}>
          Oops! The page you're looking for isn't here.
        </Typography>
        <MainButton onClick={() => navigate("/")} text="Go Home" />
      </Box>
      <Footer />
      {!isSignedIn && (
        <SignupModal
          additionalText={true}
          open={openSignUpModal}
          onClose={() => {
            setSignUpModal(false);
            window.location.assign(redirectPath || "/");
          }}
        />
      )}
    </>
  );
};

export default NotFoundPage;
